// @ngInject
function FlexGridHelperService() {

    return {
        assembleOrderArticleFlexGridData: assembleOrderArticleFlexGridData,
        assembleArticleVariantsFlexGridData: assembleArticleVariantsFlexGridData
    };

    function assembleArticleVariantsFlexGridData(article, propertyToShow) {
        var VARIANT_DETAIL_ONE_PROPERTY_NAME = "variantDetail1";
        var VARIANT_DETAIL_TWO_PROPERTY_NAME = "variantDetail2";
        var VARIANT_DETAIL_THREE_PROPERTY_NAME = "variantDetail3";  // Currently not in use (2015-05-25)
        var VARIANT_DETAIL_FOUR_PROPERTY_NAME = "variantDetail4";   // Currently not in use (2015-05-25)
        var sortedVar1s = getSortedUniqueVariants(article, VARIANT_DETAIL_ONE_PROPERTY_NAME);
        var sortedVar2s = getSortedUniqueVariants(article, VARIANT_DETAIL_TWO_PROPERTY_NAME);
        var articleVariantsHashTable = generateArticleVariantsHashTable(article);
        var returnData = [];

        for (var i = 0; i < sortedVar1s.length; i++) {
            var gridRowData = {};
            var variant1 = sortedVar1s[i];
            gridRowData["v"] = variant1.variantDetailName;
            for (var j = 0; j < sortedVar2s.length; j++) {
                var variant2 = sortedVar2s[j];
                var currentArtVar = articleVariantsHashTable[variant1.variantDetailName + variant2.variantDetailName];

                gridRowData[variant2.variantDetailName] = (currentArtVar && currentArtVar[propertyToShow]) ? currentArtVar[propertyToShow] : 0;
            }
            returnData.push(gridRowData);
        }
        return returnData;

        function getSortedUniqueVariants(article, propertyName) {
            var variantDetails = [];
            var variants = article.articleVariants;
            for (var i = 0; i < variants.length; i++) {
                var variantDetail = variants[i][propertyName];
                if (!arrayContains(variantDetails, variantDetail, "variantDetailName")) {
                    variantDetails.push(variantDetail);
                }
            }
            variantDetails.sort(function(a, b) { return a.sortOrder - b.sortOrder; });
            return variantDetails;
        }

        function generateArticleVariantsHashTable(article) {
            var hashTable = {};
            var articleVariants = article.articleVariants;
            for (var i = 0; i < articleVariants.length; i++) {
                var var1Name = articleVariants[i].variantDetail1.variantDetailName;
                var var2Name = articleVariants[i].variantDetail2.variantDetailName;

                hashTable[var1Name + var2Name] = articleVariants[i];
            }
            return hashTable;
        }

    }

    function assembleOrderArticleFlexGridData(ordArt) {
        var VARIANT_DETAIL_ONE_PROPERTY_NAME = "variantDetail1";
        var VARIANT_DETAIL_TWO_PROPERTY_NAME = "variantDetail2";
        var VARIANT_DETAIL_THREE_PROPERTY_NAME = "variantDetail3";  // Currently not in use (2015-05-07)
        var VARIANT_DETAIL_FOUR_PROPERTY_NAME = "variantDetail4";   // Currently not in use (2015-05-07)
        var rows = ordArt.orderRows;
        var sortedVar1s = getSortedUniqueVariants(ordArt, VARIANT_DETAIL_ONE_PROPERTY_NAME);
        var sortedVar2s = getSortedUniqueVariants(ordArt, VARIANT_DETAIL_TWO_PROPERTY_NAME);
        var destinations = getUniqueDestinations(ordArt);
        var rowsHashTable = generateRowsHashTable(rows); // Keys are: destination.name + articleVariant1.name + articleVariant2.name
        var returnData = {};

        for (var r = 0; r < destinations.length; r++) {
            var destName = destinations[r].locationName;
            returnData[destName] = []; // Initialize fields with empty stacks.
        }
        returnData.destinations = destinations; // For looping out the locations

        for (var h = 0; h < destinations.length; h++) {
            var destinationName = destinations[h].locationName;
            for (var i = 0; i < sortedVar1s.length; i++) {
                var gridRowData = {};
                var variant1 = sortedVar1s[i];
                gridRowData["v"] = variant1.variantDetailName;
                for (var j = 0; j < sortedVar2s.length; j++) {
                    var variant2 = sortedVar2s[j];
                    var currentDetail = rowsHashTable[destinationName + variant1.variantDetailName + variant2.variantDetailName];

                    gridRowData[variant2.variantDetailName] = (currentDetail != null) ? currentDetail.quantity : 0;
                }
                returnData[destinationName].push(gridRowData);
            }
        }
        return returnData;

        // === assembleOrderArticleFlexGridData "private" functions ===
        function getSortedUniqueVariants(orderArticle, detailFieldNameString) {
            var details = []; // Details stack
            var orderRows = orderArticle.orderRows;
            for (var i = 0; i < orderRows.length; i++) {
                var detail = orderRows[i].articleVariant[detailFieldNameString];
                if (!arrayContains(details, detail, "variantDetailName")) {
                    details.push(detail);
                }
            }
            details.sort(function(a, b) { return a.sortOrder - b.sortOrder; }); // Sort by sortOrder, ascending.
            return details;
        }

        function getUniqueDestinations(orderArticle) {
            var destinations = []; // Destinations stack
            var orderRows = orderArticle.orderRows;
            for (i = 0; i < orderRows.length; i++) {
                var destination = orderRows[i].destination;
                if (!arrayContains(destinations, destination, "locationName")) {
                    destinations.push(destination);
                }
            }
            return destinations;
        }

        function generateRowsHashTable(orderRows) {
            var hashTable = {};
            for (var i = 0; i < orderRows.length; i++) {
                var var1Name = orderRows[i].articleVariant.variantDetail1.variantDetailName;
                var var2Name = orderRows[i].articleVariant.variantDetail2.variantDetailName;
                var destName = orderRows[i].destination.locationName;

                hashTable[destName + var1Name + var2Name] = orderRows[i];
            }
            return hashTable;
        }
        // === End ===
    }

    function arrayContains(array, object, comparisonFieldName) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][comparisonFieldName] === object[comparisonFieldName]) {
                return true;
            }
        }
        return false;
    }

}

angular
    .module('services.flexGridHelperService', [])
    .factory('FlexGridHelperService', FlexGridHelperService);
